









import Vue from 'vue'
import { mapState } from 'vuex'

import HumanMotionChart from '@/components/Card/History/Chart.vue'
import { IStateThing } from '@/store/modules/thing'

export default Vue.extend({
  data() {
    return {
      loading: false
    }
  },
  components: {
    HumanMotionChart
  },
  methods: {
    getHistory() {
      const hasSerial = this.$store.state.thing.serial
      if (!hasSerial) return

      this.loading = true
      this.$store.dispatch('history/getHumanMotionEvents').finally(() => {
        this.loading = false
      })
    }
  },
  computed: {
    ...mapState<IStateThing>('thing', {
      serial: (state: IStateThing) => state.serial
    })
  },
  watch: {
    serial: function() {
      this.$store.commit('history/resetHumanMotionHistory')
      this.getHistory()
    }
  },
  mounted() {
    this.getHistory()
  },
  beforeDestroy() {
    this.$store.commit('history/resetHumanMotionHistory')
  }
})
